export default __webpack_public_path__ + "static/media/LoadingPageGraphic.262a3d41.png";